import parse from "html-react-parser";
import energyGuide from "../../pages/Wiki/Guides/Energy";

function EnergyOther() {
  return (
    <div className="p-4">
      <h1 className="wiki-main-title">{energyGuide.title}</h1>
      <p className="wiki-author">
        By {energyGuide.meta.author} on {energyGuide.meta.date}
      </p>

      {energyGuide.sections.map((section) => (
        <div key={section.id} className="wiki-sections">
          <h2 className="wiki-section-title">{section.title}</h2>
          {section.content.map((block, index) => {
            if (block.type === "text") {
              return (
                <div key={index} className="wiki-text">
                  {parse(block.data)}
                </div>
              );
            }
            return null;
          })}
        </div>
      ))}
    </div>
  );
}

export default EnergyOther;
